import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, map, catchError } from 'rxjs';
import { SlidesAccess } from 'src/app/models/slides-import.models';
import { URLService } from 'src/app/services/dynamic-url.service';
import { httpOptionsWithSkipErrorInterceptor } from 'src/app/common/functions-and-constant/interceptor';

@Injectable({
  providedIn: 'root',
})
export class SlidesAccessApiService {
  constructor(private readonly http: HttpClient, private readonly urlService: URLService) {}

  checkAccess(presentationId: string): Observable<SlidesAccess> {
    const params = new HttpParams().set('id', presentationId);
    const url = `${this.urlService.getDynamicUrl()}/spaces/slides/access`;

    return this.http
      .get<{ access: string }>(url, { ...httpOptionsWithSkipErrorInterceptor, params })
      .pipe(
        map((res) => (res.access === 'public' ? SlidesAccess.Public : SlidesAccess.Restricted)),
        catchError(() => of(SlidesAccess.Restricted)),
      );
  }
}
